import GenericService from './GenericService';
import { httpService } from './HttpService';
import { Usuario } from '@/model/Usuario';
import { CambiarPasswordDTO } from '@/model/CambiarPasswordDTO';


export class UsuarioService extends GenericService<Usuario>{
    constructor(){
        super("Usuario")
    }

    desbloquear(idUsuario: number): Promise<any> {
        return httpService.get(this.entity+"/"+idUsuario+"/desbloquear");
    }

    cambiarPassword(idUsuario: number, dto: CambiarPasswordDTO): Promise<any> {
        return httpService.post(this.entity+"/"+idUsuario+"/pass", dto);
    }
}